exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tile_wrapper[data-v-16a9b732]:hover {\r\n    background-color: #797575;\r\n    cursor: pointer;\n}\n.sub_title_wrapper[data-v-16a9b732] {\r\n    background-color: #f4f7f8;\n}\n.pointer[data-v-16a9b732] {\r\n    cursor: pointer;\n}\n#navside[data-v-16a9b732]{\r\n  background-color: #015599;\n}\r\n\r\n", ""]);

// exports
